import template from './loansDetailCollapse.html';
import controller from './loansDetailCollapse.controller';
import './loansDetailCollapse.scss';

let loansDetailCollapseComponent = {
  restrict: 'E',
  transclude: true,
  bindings: {
    title: '@',
    subtitle: '@',
    opened: '<',
    isMobileApp: '<'
  },
  template,
  controller,
};

export default loansDetailCollapseComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailCollapse/loansDetailCollapse.component.js